import { render, staticRenderFns } from "./param-data-edit.vue?vue&type=template&id=146c9cec&"
import script from "./param-data-edit.vue?vue&type=script&lang=js&"
export * from "./param-data-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports